<template>
  <v-card
    class="ma-auto pt-0"
    :class="{'card-style': readOnly}"
    :disabled="readOnly"
    variant="outlined"
  >
    <v-list>
      <v-list-item
        v-for="(item, provider) in items"
        :key="provider"
        :class="{'disable-pointer': item.isLinked || readOnly}"
        @click="linkToSocialAccounts(item)"
      >
        <template #prepend>
          <img
            class="mx-2"
            width="20px"
            height="20px"
            alt="provider-icon"
            :src="item.icon"
          >
        </template>
        <template #title>
          <span class="text-subtitle-1">{{ item.title }}</span>
        </template>
        <template #subtitle>
          <span v-if="item.isLinked" class="text-subtitle-2">{{ item.email }}</span>
        </template>
        <template #append>
          <v-row v-if="item.isLinked" class="mr-3">
            <span class="text-secondary mr-1">
              {{ $t('SocialAccounts.linked') }}
            </span>
            <v-icon color="secondary" icon="mdi-link-variant" />
          </v-row>
          <v-row v-else class="mr-3">
            <span class="text-red mr-1">{{ $t('SocialAccounts.notLinked') }}</span>
            <v-icon color="red" icon="mdi-link-variant-off" />
          </v-row>
        </template>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import axios from 'axios'
import settings from '../../settings'
import { initGoogleApi } from '../../library/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'SocialAccountState',
  props: {
    accounts: { type: Object, required: true },
    readOnly: { type: Boolean, default: false }
  },
  emits: ['link-account'],
  data: () => ({
    items: {
      // information about supported providers
      google: {
        provider: 'google',
        icon: 'https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA',
        title: 'Google',
        isLinked: false,
        email: undefined
      }
    },
    googleTokenClient: undefined
  }),
  computed: {
    ...mapGetters(['ui']),
    googleTokenConfigurations () {
      // configurations for getting google token
      return {
        client_id: this.$googleClientId,
        scope: 'https://www.googleapis.com/auth/userinfo.email'
      }
    }
  },
  watch: {
    accounts: {
      handler() {
        this.updateSocialAccounts()
      },
      deep: true
    }
  },
  created() {
    this.updateSocialAccounts()
    // initialize Google API and create token client
    if (!this.ui.googleApiLoaded) {
      initGoogleApi().then((res) => {
        this.googleTokenClient = window.google.accounts.oauth2.initTokenClient({
          ...this.googleTokenConfigurations,
          callback: this.linkGoogle })
      })
    } else {
      this.googleTokenClient = window.google.accounts.oauth2.initTokenClient({
        ...this.googleTokenConfigurations,
        callback: this.linkGoogle
      })
    }
  },
  methods: {
    linkGoogle (googleUser) {
      /**
       * Link to Google account
       * @param {object} googleUser response from Google Identity Service
       */
      axios.get('https://www.googleapis.com/oauth2/v3/userinfo', { headers: { Authorization: `Bearer ${googleUser.access_token}` } }).then((res) => {
        this.$emit('link-account', { email: res.data.email, social_id: res.data.sub, provider: 'google' })
      }).catch((error) => {
        // show error dialog
        this.$store.dispatch('alert', {
          title: this.$t('SocialAccounts.GoogleOAuthFailure'),
          body: error.data
        })
      })
    },
    linkToSocialAccounts (item) {
      /**
       * Link to social accounts
       * @param {object} item information of the target item
       */
      // do nothing if the social account is already linked
      if (item.isLinked || this.readOnly) return
      if (item.provider === 'google') {
        this.googleTokenClient.requestAccessToken()
      }
    },
    updateSocialAccounts () {
      /**
       * update the info of social accounts
       */
      this.accounts.forEach((account) => {
        // account should contain provider, email and social_id
        this.items[account.provider].isLinked = true
        this.items[account.provider].email = account.email
      })
    }
  }
}
</script>
<style>
.disable-pointer {
  pointer-events: none;
  cursor: default
}
</style>
